// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  eventId: __t.string().name("event_id"),
  eventType: __t.string().name("event_type"),
  instanceId: __t.string().name("instance_id"),
  mapId: __t.string().name("map_id"),
  sourceId: __t.string().name("source_id"),
  targetId: __t.string().name("target_id"),
  skillId: __t.string().name("skill_id"),
  amount: __t.i32(),
  targetHp: __t.i32().name("target_hp"),
  targetMaxHp: __t.i32().name("target_max_hp"),
  sourceX: __t.i32().name("source_x"),
  sourceY: __t.i32().name("source_y"),
  targetX: __t.i32().name("target_x"),
  targetY: __t.i32().name("target_y"),
  snap: __t.bool(),
  payloadJson: __t.string().name("payload_json"),
  tick: __t.i64(),
  createdAt: __t.timestamp().name("created_at"),
});
